document.addEventListener('DOMContentLoaded', () => {

    console.log('hi dom 👋');

});